import { render } from "./NotVerifiedUsers.vue?vue&type=template&id=5d508445&scoped=true&ts=true"
import script from "./NotVerifiedUsers.vue?vue&type=script&lang=ts"
export * from "./NotVerifiedUsers.vue?vue&type=script&lang=ts"

import "./NotVerifiedUsers.vue?vue&type=style&index=0&id=5d508445&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d508445"]])

export default __exports__